<alaris-dialog
		[closeAction]="close.bind(this)"
		[confirmAction]="confirm.bind(this)"
		[loading$]="clientsService.loading$"
		[confirmButtonText]="'gl.delete'"
		[disabled]="!!rules"
		size="md"
		class="removingDialog">
	<h3 slot="header">
		<app-circle-warning></app-circle-warning>
		<div>
			{{ 'clients.removing_dialog_title' | translate }}
		</div>
	</h3>
	<div slot="content">
		<p>
			@if (rules) {
				{{ 'clients.removing_error_dialog' | translate }}
				@for (id of rules; track id) {
					<li>
						<strong>{{ 'rules.id' | translate }}: {{ id }}</strong>
					</li>
				} } @else {
				{{ 'clients.removing_dialog' | translate }}
				<strong>{{ data.client.login }}</strong>
			}
		</p>
	</div>
</alaris-dialog>